<template>
  <base-dialog :showDialog="showDialog">
    <template v-slot:body>
      <v-card dark>
        <v-card-title>
          <div class="d-flex justify-space-around">
            <span class="text-h6">Item Integração</span>
          </div>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-wrap ">
            <v-text-field
              dark
              dense
              outlined
              label="Código"
              disabled
              class="text-caption mx-1"
              v-model="item.CODIGO"
            />
            <v-text-field
              dark
              dense
              outlined
              label="Descrição"
              disabled
              class="text-caption mx-1"
              v-model="item.DESCRICAO"
            />
            <v-text-field
              dark
              dense
              outlined
              label="Código Integração"
              disabled
              class="text-caption mx-1"
              v-model="item.IDINTEGRACAO"
            />
            <v-text-field
              dark
              dense
              outlined
              label="Quantidade Max. Compra"
              class="text-caption mx-1"
              v-model="item.QUANTIDADEMAXCOMPRA"
            />
            <v-text-field
              dark
              dense
              outlined
              label="Quantidade Min. Compra"
              class="text-caption mx-1"
              v-model="item.QUANTIDADEMINCOMPRA"
            />
            <v-text-field
              dark
              dense
              outlined
              label="Quantidade Crit. Estoque"
              class="text-caption mx-1"
              v-model="item.QUANTIDADECRITICA"
            />
            <v-text-field
              dark
              dense
              outlined
              label="Dias Manuseio"
              class="text-caption mx-1"
              v-model="item.DIASPARAMANIPULACAO"
            />
            <c-input-money
              v-model="item.PRECO"
              label="Preço"
              dark
              dense
              outlined
              reverse
              v-bind:valueWhenIsEmpty="'0'"
              v-bind:options="{
                locale: 'pt-BR',
                prefix: '',
                suffix: systemCurrency[0].cifrao,
                length: 11,
                precision: `${getQntDecimais(systemCurrency[0])}`,
              }"
            />
            <!-- <v-text-field dark dense outlined label="Fabricante" class="text-caption mx-1" v-model="item.FABRICANTE_INTEGRACAO" /> -->
            <v-combobox
              dark
              dense
              outlined
              label="Fabricante"
              class="text-caption mx-1"
              v-model="item.FABRICANTE_INTEGRACAO"
              :items="manufacturerComboBox"
              item-text="NOME"
              item-value="NOME"
            />
            <v-combobox
              dark
              dense
              outlined
              multiple
              label="Categorias"
              class="text-caption mx-1"
              v-model="item.CATEGORIES"
              :items="categoryComboBox"
              item-text="NOME"
              item-value="CODIGO"
            />
          </div>
          <div class="d-flex flex-wrap">
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Frete Grátis"
              class="customClass ml-2"
              v-model="item.ISFRETEGRATIS"
            />
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Super Oferta"
              class="customClass ml-2"
              v-model="item.ISPRODUTOSUPEROFERTA"
            />
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Lançamento"
              class="customClass"
              v-model="item.ISPRODUTOLANCAMENTO"
            />
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Destaque"
              class="customClass ml-2"
              v-model="item.ISPRODUTODESTAQUE"
            />
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Exclusivo"
              class="customClass ml-2"
              v-model="item.ISPRODUTOEXCLUSIVO"
            />
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Embalagem Presente"
              class="customClass ml-2"
              v-model="item.ISEMBALARPRESENTE"
            />
            <v-switch
              color="red darken-4"
              dark
              dense
              outlined
              label="Permitir Compra"
              class="customClass ml-2"
              v-model="item.ISPERMITIRCOMPRA"
            />
          </div>
        </v-card-text>
        <form-buttons @goBack="$emit('goBack')" @submitForm="saveData" />
      </v-card>
    </template>
  </base-dialog>
</template>

<script>
import FormButtons from '../../../shared/base-buttons/FormButtons.vue'
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInputMoney from '@/components/shared/base-input/BaseInputMoney.vue'

import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  components: { FormButtons, BaseDialog, cInputMoney },
  computed: {
    ...mapGetters({
      categoryComboBox: 'isetModule/getCategoryIntegratedComboBox',
      manufacturerComboBox: 'isetModule/getManufacturerComboBox',
      systemCurrency: 'systemModule/getSystemCurrencies',
    }),
    ...mapState('currencyModule', ['currency']),
  },
  data: () => {
    return {
      item: {},
    }
  },
  methods: {
    ...mapActions({
      getCategoriesIntegration: 'isetModule/getCategories',
      getManufacturers: 'isetModule/getManufacturers',
    }),
    saveData() {
      this.$emit('submitForm', this.item)
    },
    async requestCategories() {
      await this.getCategoriesIntegration({ todos: 'S', integrados: 'S' })
    },
    async requestManufacturers() {
      await this.getManufacturers()
    },
    getQntDecimais(currency) {
      return currency.mascara.indexOf('.') != -1 ? 2 : 0
    },
  },
  mounted() {
    if (this.objectData.CODIGO) this.item = { ...this.objectData }
    if (this.categoryComboBox.length <= 0) this.requestCategories()
    if (this.manufacturerComboBox.length <= 0) this.requestManufacturers()
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    objectData: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
}
</script>

<style lang="css" scoped>
.customClass >>> label {
  font-size: 0.9em;
}
</style>
